<mat-expansion-panel
  hideToggle
  class="status-section"
  [disabled]="isDisabled"
>
  <mat-expansion-panel-header
    class="accordion-header"
  >
    <mat-panel-title class="section-heading">
      <div
        class="stepper-block"
        [class.disabled]="isDisabled"
      >
        <div class="stepper-circle"></div>
        <div class="stepper-line"></div>
      </div>
      <div class="header">
        <div class="line-1">
          <div class="block-heading">Schedule</div>
          <div class="section-heading">
            {{ subheading }}
          </div>
        </div>
        <mat-icon
          class="line-2 chevron-icon"
          [svgIcon]="isExpanded ? 'chevron-up' : 'chevron-down'"
        />
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div
    class="content-section"
    [class.disabled]="isDisabled"
  >
    <div class="section first">
      <div class="section-heading">LAB CONTACTS:</div>
      <div class="section-subheading">{{data?.lab?.email}}</div>
      <div class="section-subheading">{{data?.lab?.phone}}</div>
    </div>
    <div class="section">
      <div class="section-heading">RECEIVED ON:</div>
      <div class="section-subheading">{{data?.lab?.email}}</div>
    </div>
  </div>
</mat-expansion-panel>
